<div class="ai-suggestion">
  <div
    class="ai-suggestion__header ai-suggestion__row"
    [class.ai-suggestion__header-disabled]="state.disabled()"
  >
    <div class="ai-suggestion__row-left-container">
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="25"
          height="25"
          stroke="#6B4FA3"
        />
        <path
          d="M11.722 8.62L15.334 18H13.836L12.968 15.578H8.922L8.068 18H6.584L10.196 8.62H11.722ZM9.342 14.388H12.548L10.952 9.88L9.342 14.388ZM18.0741 18H16.7021V8.62H18.0741V18Z"
          fill="#6B4FA3"
        />
      </svg>
      <span>Updates</span>
    </div>
    <div class="ai-suggestion__row-right-container">
      @if (!formModeService.isShowMode()) {
        <p>
          <mat-slide-toggle
            [checked]="!state.disabled()"
            (change)="disableUpdates($event)"
          >
            Enable updates
          </mat-slide-toggle>
        </p>
      }

      @if (formModeService.isShowMode() && state.disabled()) {
        <mat-icon
          class="ai-suggestion__row-right-container__icon"
          matTooltip="Updates Disabled"
          >do_disturb</mat-icon
        >
      }
    </div>
  </div>
  @if (!state.disabled()) {
    <div class="ai-suggestion__content">
      <div class="ai-suggestion__content__updates">
        <mat-stepper
          #stepper
          orientation="vertical"
          [linear]="true"
        >
          @for (update of aiUpdates()?.updates; track $index) {
            <mat-step>
              <ng-template matStepLabel>
                <div class="ai-suggestion__content__update">
                  <p>{{ update }}</p>
                  <div class="ai-suggestion__content__update__actions">
                    <mat-icon
                      class="ai-suggestion__content__update__icon"
                      matTooltip="Pin"
                    >
                      push_pin</mat-icon
                    >
                    <mat-icon
                      class="ai-suggestion__content__update__icon"
                      matTooltip="Not Relevant"
                    >
                      thumb_down</mat-icon
                    >
                    <mat-icon
                      class="ai-suggestion__content__update__icon"
                      matTooltip="Copy"
                    >
                      content_copy</mat-icon
                    >
                  </div>
                </div>
              </ng-template>
              <div class="ai-suggestion__content__updates__sources">
                <p>17.07.2025</p>
                <a>Sources</a>
              </div>
            </mat-step>
          }
        </mat-stepper>
      </div>
    </div>
  }
</div>
